var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"process"},[_c('h2',[_vm._v("Process")]),_c('p',[_c('ol',_vm._l((_vm.process.items),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])}))])])}
var staticRenderFns = []

export { render, staticRenderFns }